import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const CloudDownload = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M16.75 19.25h1.375a4.125 4.125 0 1 0-.13-8.248q.005-.126.005-.252A6 6 0 0 0 6.326 8.793 5.251 5.251 0 0 0 7 19.25h.25m4.75-7.5v7.5m0 0 2.5-2.5m-2.5 2.5-2.5-2.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.78 8.124a6.751 6.751 0 0 1 12.954 2.164A4.876 4.876 0 0 1 18.125 20H7A6 6 0 0 1 5.78 8.124m5.47.626a.75.75 0 0 1 1.5 0v5.69l1.22-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.22 1.22z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
